import loadable from '@loadable/component'
import { SiteHeader } from './SiteHeader'

export const ProspectSiteHeader = loadable(() => import('./ProspectSiteHeader'))

export { SiteHeader }
export { TOP_ANCHOR_ID } from './SiteHeader'
export type {
  LinkButtonProps,
  MarketoButtonProps,
  ProspectSiteHeaderProps
} from './ProspectSiteHeader'
export type { SiteHeaderProps } from './SiteHeader'
